module.exports = __webpack_public_path__ + "static/media/4.Sprinkle Pipes.489968e7.jpeg";